import { clsx } from 'clsx';
import { type FC, type PropsWithChildren } from 'react';

import styles from './CardListLayout.css';

export const CardList: FC<PropsWithChildren<{ isNarrow?: boolean; isResponsive?: boolean }>> = ({
  children,
  isNarrow,
}) => <div className={clsx('card-list', isNarrow && 'card-list_narrow', 'card-list_responsive')}>{children}</div>;

export const CardListItem: FC<PropsWithChildren<{ dataTestId?: string }>> = ({ children, dataTestId }) => (
  <div className={clsx(styles['card-wrapper'])} data-testid={dataTestId}>
    {children}
  </div>
);
export const AdfoxParallaxBannerWrapper: FC<PropsWithChildren> = ({ children }) => (
  <div className={styles['adfox-parallax-banner-wrapper']}>{children}</div>
);
export const AdfoxTgbBannerWrapper: FC<PropsWithChildren> = ({ children }) => (
  <div className={styles['adfox-tgb-banner-wrapper']}>{children}</div>
);
